import { render, staticRenderFns } from "./BaseCTAtxt.vue?vue&type=template&id=fc6fecac&scoped=true&"
import script from "./BaseCTAtxt.vue?vue&type=script&lang=js&"
export * from "./BaseCTAtxt.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=fc6fecac&scoped=true&lang=css&"
import style1 from "./BaseCTAtxt.vue?vue&type=style&index=1&id=fc6fecac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6fecac",
  null
  
)

export default component.exports